export const ROLE_LABELS = {
  admin: "Administrator",
  "user-verwaltung": "Verwaltung",
  "user-katechet": "Katechet:in",
  user: "Eltern",
  "user-kind": "Kind",
};

export const ROLE_OPTIONS = [
  { value: "admin", label: "Administrator" },
  { value: "user-verwaltung", label: "Verwaltung" },
  { value: "user-katechet", label: "Katechet:in" },
  { value: "user", label: "Eltern" },
];

export const TYP_OPTIONS = {
  m: ["Pfarrer", "Diakon", "Gemeindereferent", "Pastoralreferent", "Verwaltungsangestellter", "Katechet"],
  w: ["Gemeindereferentin", "Pastoralreferentin", "Verwaltungsangestellte", "Katechetin"],
};

export const STAFF_ROLES = ["admin", "user-verwaltung", "user-katechet"];

export const SAKRAMENT_LABELS = { TA: "Taufe", EK: "Erstkommunion", FI: "Firmung", EH: "Eheschließung" };

export const userRoles = (user) =>
  user?.roles && user.roles.length ? user.roles : user?.role ? [user.role] : [];
export const isStaffUser = (user) => userRoles(user).some((r) => STAFF_ROLES.includes(r));
export const hasRole = (user, role) => userRoles(user).includes(role);
export const rolesLabel = (user) => userRoles(user).map((r) => ROLE_LABELS[r] || r).join(", ");

export const DATENSCHUTZ_TEXT = `Einwilligungserklärung für die Veröffentlichung von personenbezogenen Daten (Namen / Fotos / Filmaufnahmen) durch die Pfarrei Mariä Himmelfahrt Otterberg

Hiermit willige/n ich/wir ein,

• dass der/die Name/n (ohne Anschrift) in Verbindung mit der Sakramentenspendung (Taufe, Erstkommunion) und der kirchlichen Gemeinde,

• dass Fotoaufnahmen/Filmaufnahmen erstellt und
  – im Pfarrbrief (der auch auf der Homepage veröffentlicht wird),
  – dem Schaukasten der Pfarrei / Infotafeln in der Kirche,
  – in der Tagespresse,
  – im Internetauftritt (Homepage der Pfarrei),
  – sonstige Präsentationen (z. B. Infoabend)

veröffentlicht werden darf.

Mit dieser Zustimmung zur Abbildung und Veröffentlichung erkläre ich auch, dass ich aus einer Verwendung des/der Fotos keine Rechte, insbesondere keine Entgeltansprüche, geltend machen werde.

Mir/uns wurde erläutert, dass die Erklärung meines/unseres Einverständnisses völlig freiwillig und bis auf Widerruf gültig ist. Der Widerruf kann jederzeit mit Wirkung für die Zukunft erfolgen und ist schriftlich an das zuständige Pfarrbüro zu richten.`;
